import * as types from "../../ActionType";

const initState = {
    suppplierss: [],
    loadingSuppplierss: true
}

const SuppliersReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_SUPPLIER:
            return { ...state, loadingSuppplierss: true }
        case types.GET_SUPPLIERSS:
            return { ...state, suppplierss: action.payload, loadingSuppplierss: false }
        case types.DELETE_SUPPLIER:
            return { ...state}
        case types.EDIT_SUPPLIER:
            return { ...state, loadingSuppplierss: true }
        default:
            return state;
    }
};

export default SuppliersReducer;
